import axiosClient from "utils/axios";
import { ApiList, ApiResponse } from "../../../types/api.types";
import type {
  CreatePurchaseOrderPayload,
  PurchaseOrder,
  PurchaseOrderListFilters,
  UpdatePurchaseOrderPayload,
} from "features/PurchaseOrders/types/purchase-order.types";

export const getPurchaseOrders = async (
  params: PurchaseOrderListFilters = {},
) => {
  const { page = 1, limit = 10, search, status, supplierId } = params;
  try {
    const response = await axiosClient.post<ApiResponse<ApiList<PurchaseOrder[]>>>(
      "/purchase-orders/list",
      {
        page,
        limit,
        ...(search ? { search } : {}),
        ...(status ? { status } : {}),
        ...(supplierId != null && supplierId > 0 ? { supplierId } : {}),
      },
    );
    return response.data;
  } catch (err) {
    console.warn("Error fetching purchase orders:", err);
    throw err;
  }
};

export const createPurchaseOrder = async (
  payload: CreatePurchaseOrderPayload,
) => {
  try {
    const response = await axiosClient.post<ApiResponse<PurchaseOrder>>(
      "/purchase-orders",
      payload,
    );
    return response.data;
  } catch (err) {
    console.warn("Error creating purchase order:", err);
    throw err;
  }
};

export const updatePurchaseOrder = async (
  id: number,
  payload: UpdatePurchaseOrderPayload,
) => {
  try {
    const response = await axiosClient.put<ApiResponse<PurchaseOrder>>(
      `/purchase-orders/${id}`,
      payload,
    );
    return response.data;
  } catch (err) {
    console.warn("Error updating purchase order:", err);
    throw err;
  }
};

export const getPurchaseOrder = async (id: number) => {
  if (!Number.isInteger(id) || id <= 0) {
    throw new Error("Invalid ID");
  }
  try {
    const response = await axiosClient.get<ApiResponse<PurchaseOrder>>(
      `/purchase-orders/${id}`,
    );
    return response.data;
  } catch (err) {
    console.warn("Error fetching purchase order:", err);
    throw err;
  }
};

export const confirmPurchaseOrder = async (id: number) => {
  try {
    const response = await axiosClient.post<ApiResponse<PurchaseOrder>>(
      `/purchase-orders/${id}/confirm`,
      {},
    );
    return response.data;
  } catch (err) {
    console.warn("Error confirming purchase order:", err);
    throw err;
  }
};

export const cancelPurchaseOrder = async (id: number) => {
  try {
    const response = await axiosClient.post<ApiResponse<PurchaseOrder>>(
      `/purchase-orders/${id}/cancel`,
      {},
    );
    return response.data;
  } catch (err) {
    console.warn("Error cancelling purchase order:", err);
    throw err;
  }
};
